// test1781
(1781 && 0);
